module.exports = __webpack_public_path__ + "static/media/ea-logo-results.5279968f.jpg";